import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChangeLogs } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemInternalTransaction from '../hooks/use-internal';

const InternalTransactionChangeLog = (): React.JSX.Element => {
  const { changeLogs, changeLogsPagination } = useAppSelector(
    (state) => state.customersProblemTransactions.internal,
  );
  const { users } = useAppSelector((state) => state.administrationDictionaries);
  const { activePermissions } = useAppSelector((state) => state.root);

  const { transactionId } = useParams();

  const { changeLogsIsLoading, changeLogsIsFetching, getChangeLogsAction } =
    useProblemInternalTransaction({
      transactionId,
    });

  useEffect(() => {
    getChangeLogsAction();
  }, []);

  return (
    <ChangeLogs
      entityType="TRANSACTION"
      entityId={transactionId as string}
      changeLogsIsLoading={changeLogsIsLoading}
      changeLogs={changeLogs}
      activePermission={activePermissions}
      users={users}
      pagination={changeLogsPagination}
      changeLogsIsFetching={changeLogsIsFetching}
      getChangeLogs={getChangeLogsAction}
    />
  );
};

export default InternalTransactionChangeLog;
